module.exports = __webpack_public_path__ + "img/Botswana.42fce18b.png";